<ng-container *ngIf="alert" [ngSwitch]="alert.cleared">
    <ng-container *ngSwitchCase="false">
        {{ 'alert-center.instance.unresolved' | translate }}
    </ng-container>

    <nz-tag *ngSwitchCase="true" class="adspt-tag-success-line">
        {{ 'alert-center.instance.resolved' | translate }}
    </nz-tag>
</ng-container>
